import React from 'react'
import propTypes from 'prop-types'
import Popover from '@material-ui/core/Popover'

const elevation = 3

const getStyles = (props) => {
  const {padded = true} = props

  return {
    root: {
      padding: padded ? 20 : 0,
    },
  }
}

const _Popover = (props) => {
  const {
    children,
    anchor,
    open,
    align,
    className,
    onRequestClose,
  } = props
  const styles = getStyles(props)

  return (
      <Popover
          anchorEl={anchor}
          open={open}
          classes={className ? {paper: className} : undefined}
          onClose={onRequestClose}
          onClick={(e) => e.stopPropagation()}
          anchorOrigin={{vertical: 'top', horizontal: align}}
          transformOrigin={{vertical: 'top', horizontal: align}}
          elevation={elevation}
          PaperProps={{style: styles.root}}
          disableRestoreFocus={true}
      >
        {children}
      </Popover>
  )
}

_Popover.propTypes = {
  open: propTypes.bool.isRequired,
  onRequestClose: propTypes.func.isRequired,
  anchor: propTypes.object,
  align: propTypes.oneOf(['left', 'right']),
  children: propTypes.any,
  className: propTypes.string,
}

_Popover.defaultProps = {
  align: 'left',
}

export default _Popover
